import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { HONEYPOT_FIELD } from "@/lib/honeypot";

/**
 * Decoy input hidden from sight, screen readers and tab order. Real people
 * never fill it; bots that populate every input do.
 */
export const HoneypotField = React.forwardRef<HTMLInputElement>(function HoneypotField(_props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      position: "absolute",
      width: "1px",
      height: "1px",
      overflow: "hidden",
      clip: "rect(0 0 0 0)",
      whiteSpace: "nowrap"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== ref) {
    t1 = <div aria-hidden="true" style={t0}><input ref={ref} type="text" name={HONEYPOT_FIELD} tabIndex={-1} autoComplete="off" defaultValue="" /></div>;
    $[1] = ref;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
});